import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../components/ui/Card';
import { listOpenSurveys } from './surveysApi';
import type { SurveyInstrumentSummary } from './types';

/** Links to any surveys currently open for the student. Takes no props. */
export default function SurveyLinks() {
  const [instruments, setInstruments] = useState<SurveyInstrumentSummary[] | null>(null);

  useEffect(() => {
    listOpenSurveys().then(setInstruments).catch(() => setInstruments([]));
  }, []);

  const open = (instruments ?? []).filter((i) => i.is_open && !i.completed);

  return (
    <Card className="p-4">
      <h3 className="text-sm font-semibold text-ws-ink">Surveys</h3>
      {instruments === null && <p className="mt-2 text-xs text-ws-ink-3">Loading…</p>}
      {instruments !== null && open.length === 0 && (
        <p className="mt-2 text-xs text-ws-ink-3">Nothing open right now.</p>
      )}
      {open.length > 0 && (
        <ul className="mt-2 space-y-1.5">
          {open.map((i) => (
            <li key={i.key}>
              <Link to={`/surveys/${i.key}`} className="text-sm font-medium text-ws-accent-ink hover:underline">
                {i.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
